import { atom } from "jotai";

export const sidebarPinnedAtom = atom<boolean>(false);
